/* eslint*/
import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../auth.service';
import { CookieService } from 'ngx-cookie-service';
// import * as jwt_decode from "jwt-decode";
import jwt_decode from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {

  public redirectTo: string;

  private router: Router;

  constructor(
    private authService: AuthService,
    private cookieService: CookieService
    //private location: Location,
    //activatedRoute: ActivatedRoute,
    //router: Router
  ) {

    //
    //this.router = router;
    //this.redirectTo = activatedRoute.snapshot.data["redirectTo"];

  }

  //http://localhost:4201/app1#app1/test-stuff/wrapper

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    let retVal = false; //buy defaulty routes are blocked 

    //var isLoggedIn = this.authService.isLoggedIn; //we are getting this via a public getter not directly from private var


    let tokenFromBackend = this.cookieService.get('authTokenFromBackend');

    if (tokenFromBackend != "") {

      let decodedToken = this.getDecodedAccessToken(tokenFromBackend);

      var expirationDateAndTime = new Date(decodedToken.Expiration)
      var currentDateAndTime = new Date(Date.now());

      var isExpired = false;

      if (currentDateAndTime > expirationDateAndTime) {

        isExpired = true
        retVal = false;

      } else {

        retVal = true;

      }

      let returnUrl = route.routeConfig.path;


    }

    // if (!isLoggedIn || isExpired) {

    //   if (window.location.origin.includes("localhost")) {

    //     let url: URL = new URL("http://localhost:4204");

    //     //TODO NEED TO CHECK LONGER ROUTES WITH / and # and subroutes
    //     //location.replace("http://localhost:4204?returnUrl=" + returnUrl)

    //     //WILL MESS UP LOCAL STORAGE!
    //     //location.replace("http://localhost:4204?returnUrl=" + window.location.href)

    //     document.location = "http://localhost:4204?returnUrl=" + window.location.href;
    //     //history.pushState(null, null, "http://localhost:4204?returnUrl=" + window.location.href);


    //   } else {

    //     //TODO Add here prod URL

    //   }


    // }

    return retVal;

  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {

    let retVal = false;

    //retVal = this.authService.isLoggedIn; //we are getting this via a public getter not directly from private var

    let returnUrl = childRoute.routeConfig.path;
    if (!retVal) {

      if (window.location.origin.includes("localhost")) {

        let url: URL = new URL("http://localhost:4204");

        //TODO NEED TO CHECK LONGER ROUTES WITH / and # and subroutes
        //location.replace("http://localhost:4204?returnUrl=" + returnUrl)

        //WILL MESS UP LOCAL STORAGE!
        //location.replace("http://localhost:4204?returnUrl=" + window.location.href)

        document.location = "http://localhost:4204?returnUrl=" + window.location.href;
        //history.pushState(null, null, "http://localhost:4204?returnUrl=" + window.location.href);


      } else {

        //TODO Add here prod URL

      }

    }

    return retVal;


  }

  //https://stackoverflow.com/questions/48075688/how-to-decode-the-jwt-encoded-token-payload-on-client-side-in-angular
  getDecodedAccessToken(token: string): any {

    try {

      return jwt_decode(token);

    } catch (Error) {

      return null;

    }
  }

}